import styled from 'styled-components';
import { leftRightSpacingHelper, topBottomSpacingHelper } from '@modifi/ui-helper';
import { getStylesFromTheme, textAlignMixin, colorMixin } from '../common';
import { headlineDefaultProps, headlinePropTypes } from './props';
var H2 = /*#__PURE__*/styled.h2.withConfig({
  displayName: "H2",
  componentId: "sc-c9w43q-0"
})(["", " ", " ", " ", " ", ""], getStylesFromTheme('h2'), colorMixin, textAlignMixin, topBottomSpacingHelper, leftRightSpacingHelper);
H2.propTypes = headlinePropTypes;
H2.defaultProps = headlineDefaultProps;
export default H2;